import React from 'react';
import { Typography, Card, Row, Col, Statistic } from 'antd';
import { UserOutlined, ShoppingCartOutlined, FileOutlined, TeamOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Dashboard: React.FC = () => {
  return (
    <div>
      <Title level={2}>仪表盘</Title>
      
      <Row gutter={16}>
        <Col span={6}>
          <Card>
            <Statistic
              title="用户总数"
              value={1128}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#529C8A' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="岗位数量"
              value={42}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#529C8A' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="产品数量"
              value={93}
              prefix={<ShoppingCartOutlined />}
              valueStyle={{ color: '#529C8A' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="文件数量"
              value={56}
              prefix={<FileOutlined />}
              valueStyle={{ color: '#529C8A' }}
            />
          </Card>
        </Col>
      </Row>

      <div style={{ marginTop: '20px' }}>
        <Card title="系统信息" style={{ marginBottom: '20px' }}>
          <p><strong>版本号：</strong> v1.0.0</p>
          <p><strong>更新时间：</strong> 2023-05-20</p>
          <p><strong>系统状态：</strong> <span style={{ color: '#52c41a' }}>正常</span></p>
        </Card>
        
        <Card title="最近活动">
          <p>暂无活动记录</p>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard; 